export interface SpinnerProps {
    size?: number
    width?: number
}

export const Spinner: React.FC<SpinnerProps> = (props) => {
    const { size = 80, width = 8 } = props
    const sizePx = `${size.toString()}px`
    const widthPx = `${width.toString()}px`
    const maskImageRadiusPx = `${(size / 2 - width).toString()}px`
    const maskImage = `radial-gradient(transparent ${maskImageRadiusPx}, black ${maskImageRadiusPx})`

    return (
        <div className="relative" style={{ width: sizePx, height: sizePx }}>
            <div className="absolute inset-0 animate-spin-reverse">
                <div
                    className="absolute inset-0 rotate-180 rounded-full"
                    style={{
                        background: `conic-gradient(currentColor 0deg, transparent 360deg)`,
                        maskImage: maskImage,
                        WebkitMaskImage: maskImage,
                    }}
                />
                <div
                    className="absolute inset-0 m-auto mb-0 translate-x-1/2 overflow-hidden"
                    style={{ width: widthPx, height: widthPx }}
                >
                    <div className="absolute inset-0 -translate-x-1/2 rounded-full bg-[currentColor]" />
                </div>
            </div>
        </div>
    )
}

export const WidgetSpinner = () => {
    /* 
        in the design files the spinner for this component is 16px and the thickness is 2.4px 
        for this reason decided to render the spinner as 40px with a thickness of 6px
        and then scale it down to 40%
    */
    return (
        <div className="relative mx-auto h-4 w-4" data-testid="widget-spinner">
            <div className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 scale-[0.4] text-neutral-400">
                <Spinner size={40} width={6} />
            </div>
        </div>
    )
}
